import { createSelector } from 'reselect';

const totesEstacions = (state) => {
    if (!state.observacio.estacio.totes) {
        return null;
    }

    return state.observacio.estacio.totes;
};
const codiEstacio = state => state.observacio.estacio.codiSeleccionada;

/**
 * Recupera una estacio a partir del seu codi.
 *
 * @param totesEstacions
 * @param codiEstacio
 * @returns {*}
 */
const obtenirDetallEstacio = (totesEstacions, codiEstacio) => {
    if (!codiEstacio || !totesEstacions) {
        return null;
    }

    var estacioTrobada = totesEstacions.find(function (estacio) {
        return (estacio.codi === codiEstacio);
    });

    return estacioTrobada || null;
};

const selector = createSelector(
    totesEstacions,      //Totes les estacions d'un usuari
    codiEstacio,
    obtenirDetallEstacio
);
export default selector;



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_per_codi.js